import { assert, isDefined } from '@sama/js-core';
import { isUndefined } from 'lodash';
import { ShapeState } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { UpsertShapeOperation } from '../../../../../team-apis/otterdam/annotation-operations/shape-operations';
import { Output } from '../../../../../team-apis/otterdam/outputs/output';
import { getInternalToExternalConverter } from '../../../../shared/internal-external-converters/internal-to-external-shape-converter';
import { ShapeOperationBuilderParams } from './shape-operation-builder-params';

export class UpsertShapeOperationBuilder {
  private currentShape?: ShapeState;
  private previousShape?: ShapeState;
  private output: Output;

  constructor({
    currentShape,
    previousShape,
    output,
  }: ShapeOperationBuilderParams) {
    this.currentShape = currentShape;
    this.previousShape = previousShape;
    this.output = output;
  }

  canBuild() {
    if (isUndefined(this.currentShape)) {
      return false;
    }
    const areTagsModified = this.currentShape.tags !== this.previousShape?.tags;
    const isTypeModified = this.currentShape.type !== this.previousShape?.type;

    return areTagsModified || isTypeModified;
  }

  build(): UpsertShapeOperation {
    assert(this.currentShape, 'shape should be defined for upsert');
    const { parentId } = this.currentShape;
    assert(
      isDefined(parentId),
      'objectId should be defined to use the annotation store',
    );
    const { tags, type } = getInternalToExternalConverter(
      this.output,
    ).convertToOperationAttributes(this.currentShape);

    return {
      operation: 'UPSERT_SHAPE',
      ids: {
        shapeId: this.currentShape.index,
        objectId: parentId,
      },
      attributes: {
        tags,
        type,
      },
      outputId: this.output.id,
    };
  }
}
